export declare namespace AppValueSectionTokenSections {
	interface Title {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
	}

	interface FieldTitle {
		color: string;
		fontWeight: string;
	}

	interface Content {
		title: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
		value: {
			color: string;
			fontWeight: string;
			fontSize: string;
			lineHeight: string;
		};
	}
}

export type AppValueSectionTokens = {
	title: AppValueSectionTokenSections.Title;
	fieldTitle: AppValueSectionTokenSections.FieldTitle;
	gap: string;
	content: AppValueSectionTokenSections.Content;
};

export const title: AppValueSectionTokenSections.Title = {
	color: '{surface.300}',
	fontWeight: '400',
	fontSize: '1rem',
	lineHeight: '1.5rem',
};

/** The title of a field-style section, read like the form field label (`app-input-label`, bold by default). */
export const fieldTitle: AppValueSectionTokenSections.FieldTitle = {
	color: '{appText.fieldLabel.color}',
	fontWeight: '600',
};

export const content: AppValueSectionTokenSections.Content = {
	title: {
		color: '{surface.300}',
		fontWeight: '400',
		fontSize: '1rem',
		lineHeight: '1.5rem',
	},
	value: {
		color: '{surface.800}',
		fontWeight: '400',
		fontSize: '1rem',
		lineHeight: '1.625rem',
	},
};

export default {
	title,
	fieldTitle,
	gap: '0.5rem',
	content,
} satisfies AppValueSectionTokens;
